const styles = {
  linkView: {
    marginRight: 16,
    width: "20%",
  },
  button: {
    marginRight: 16,
  },
};

export default styles;
